import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import Profile from "./Profile";

const routes = [
    {
        path: 'users',
        element: <List />
    },
    {
        path: 'users/create',
        element: <Create />
    },
    {
        path: 'users/profile',
        element: <Profile />
    },
    {
        path: 'users/edit/:id',
        element: <Edit />
    }
]
export default routes;